import PropTypes from 'prop-types';
import React from 'react';

import { DecisionBadge } from 'common-src/components/base';

import { getOutcomeState } from './mocaPrompt';
import useMocaPrompt from './useMocaPrompt';

const MocaStateBadge = ({ appt }) => {
  const moca = useMocaPrompt(appt, 'Provider HUD');
  if (!appt?.lowMocaPrompt) return null;
  const { tone, label } = getOutcomeState(moca.state);

  return (
    <DecisionBadge tone={tone} withIcon>
      {label}
    </DecisionBadge>
  );
};

MocaStateBadge.propTypes = { appt: PropTypes.object };

export default MocaStateBadge;
